import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { PosAttachmentsComponent } from './pos-attachments.component';



@NgModule({
  declarations: [PosAttachmentsComponent],
  imports: [
    CommonModule,
    AccordionModule.forRoot()
  ],
  exports: [PosAttachmentsComponent]
})
export class PosAttachmentsModule { }
